/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionFilterDto } from '../../models/transaction-filter-dto';
import { TransactionsListResponseDto } from '../../models/transactions-list-response-dto';

export interface TransactionsControllerFilterTransactions$Params {
      body: TransactionFilterDto
}

export function transactionsControllerFilterTransactions(http: HttpClient, rootUrl: string, params: TransactionsControllerFilterTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionsListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, transactionsControllerFilterTransactions.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionsListResponseDto>;
    })
  );
}

transactionsControllerFilterTransactions.PATH = '/keus-payments/transactions/filter';
